if(typeof Checkout != 'undefined') {
	Checkout.$(document).on('page:load page:change', function() {
    if($('.product-table').length > 0) {
      $('.product-table tr.product').each(function(i){
      	let title = $(this).find('.product__description__name').text().toLowerCase();
      	if(title == 'personalized fee') {
      		$(this).hide();
      	}

      	let line_price = parseFloat($(this).find('.product__price .order-summary__emphasis').text().replace('$', ''));
      	let qty = parseInt($(this).find('.product-thumbnail__quantity').text());
      	let pz_price = 0;
      	if($(this).find('.product__description__property').length > 0) {
      		$(this).find('.product__description__property').each(function(){
      			let property = $(this).text().split(':');
      			if(property[0].trim().toLowerCase() == 'personalized fee') {
      				pz_price = parseFloat(property[1].replace('$', ''));
      			}
      		});
      	}

      	if(pz_price > 0) {
      		let line_price_with_pz = line_price + pz_price * qty;
      		$(this).find('.product__price .order-summary__emphasis').text('$' + line_price_with_pz.toFixed(2));
      	}
      });
    }
	});
}


// WEBPACK FOOTER //
// ../assets/js/checkout.js